import * as React from 'react';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import errorNotice from '../../assets/Error_notice.png';
import {useTranslation} from 'react-i18next';
import {
  MOBILE_ERROR_TYPE,
  MOBILE_ERROR_TYPE_TO_MESSAGE, PAYMENT_STATUS,
  POST_MESSAGE_CONTENT_MESSAGE, POST_MESSAGE_TYPE
} from '../../common/constants';
import styles from '../../css/SamsungPayMobileBox.module.css';
import classNames from 'classnames/bind';
import SamsungPayMobileBox from '../../components/common/SamsungPayMobileBox';
import {postMessageToOpener} from '../../utils/postMessage';
import {useSelector} from 'react-redux';

const cx = classNames.bind(styles);

export default function MobileErrorPage() {
  const {t} = useTranslation();
  const location = useLocation();
  const [isCloseButtonClicked, setIsCloseButtonClicked] = useState(false);
  const errorType = location.state?.errorType || MOBILE_ERROR_TYPE.OTHER_ERRORS;
  const {sourceOrigin} = useSelector((state) => state.paymentClient);

  useEffect(() => {
    const handleDiscontinuedTransaction = (e) => {
      //this will trigger once the page is about to be unloaded
      if (!e.persisted && !isCloseButtonClicked) {
        postMessageToOpener({
          type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
          content: {
            status: PAYMENT_STATUS.FAIL,
            message: POST_MESSAGE_CONTENT_MESSAGE.USER_CANCEL
          },
          sourceOrigin: sourceOrigin
        });
      }
    };

    window.addEventListener('pagehide', handleDiscontinuedTransaction);

    return () => {
      window.removeEventListener('pagehide', handleDiscontinuedTransaction);
    };
  }, [sourceOrigin, isCloseButtonClicked]);

  const getContentMessage = (errorType) => {
    let contentMessage = '';

    switch (errorType) {
    case MOBILE_ERROR_TYPE.USER_CANCEL:
      contentMessage = POST_MESSAGE_CONTENT_MESSAGE.USER_CANCEL;
      break;
    case MOBILE_ERROR_TYPE.PAYMENT_TIMEOUT:
      contentMessage = POST_MESSAGE_CONTENT_MESSAGE.PAYMENT_TIMEOUT;
      break;
    case MOBILE_ERROR_TYPE.OTHER_ERRORS:
    default:
      contentMessage = POST_MESSAGE_CONTENT_MESSAGE.PAYMENT_ERROR;
    }

    return contentMessage;
  };

  const handleCloseButtonClick = () => {
    setIsCloseButtonClicked(true);

    postMessageToOpener({
      type: POST_MESSAGE_TYPE.PAYMENT_RESULT,
      content: {
        status: PAYMENT_STATUS.FAIL,
        message: getContentMessage(errorType)
      },
      sourceOrigin: sourceOrigin
    });
  };

  useEffect(() => {
    if (isCloseButtonClicked) {
      self.close();
    }
  }, [isCloseButtonClicked]);

  return (
    <SamsungPayMobileBox mobilePageType="status" closeButtonFunction={handleCloseButtonClick}>
      <div>
        <p className={cx('txt')}>
          <img src={errorNotice} className={cx('ico-error')} alt="error notice logo"/>
          {t(MOBILE_ERROR_TYPE_TO_MESSAGE[errorType])}
        </p>
      </div>
    </SamsungPayMobileBox>
  );
}